// Release notes for v1.3.2 and earlier, which aren't in Supabase.
// Copied from the App Store version history
// (https://apps.apple.com/au/app/toastie-health-tracker/id6736644572) and always
// shown after the entries fetched from the database. The App Store doesn't label
// items, so each type was assigned from its wording.
//
// Ids are negative so they never collide with database ids.

import { ChangelogEntry } from './changelogData';

export const legacyChangelog: ChangelogEntry[] = [
  {
    id: -1,
    version: '1.3.2',
    release_month: 1788220800, // 20 Sep 2026
    changelog_entry_items: [
      { id: -1, type: 'new_feature', platform: 'all', text: 'Add and track medication from your Home Screen widgets' },
      { id: -2, type: 'new_feature', platform: 'all', text: 'Add Home screen widget entrypoint and banner on settings page' },
      { id: -3, type: 'new_feature', platform: 'all', text: 'Export your doctor summary as a PDF' },
      { id: -4, type: 'new_feature', platform: 'all', text: '7-day free trial for all subscriptions' },
      { id: -5, type: 'new_feature', platform: 'all', text: 'Commit to your health with Toastie' },
      { id: -6, type: 'new_feature', platform: 'all', text: 'Feedback banner' },
      { id: -7, type: 'new_feature', platform: 'all', text: 'Share feedback and opt in to follow-up emails' },
      { id: -8, type: 'new_feature', platform: 'all', text: 'Report bugs directly from error messages' },
      { id: -9, type: 'new_feature', platform: 'all', text: 'Manage your email notification preferences' },
      { id: -10, type: 'new_feature', platform: 'all', text: 'Highlight guide on settings page' },
    ],
  },
  {
    id: -2,
    version: '1.3.1',
    release_month: 1785542400, // 22 Aug 2026
    changelog_entry_items: [
      { id: -11, type: 'new_feature', platform: 'all', text: 'See insights and trends in your doctor summary' },
      { id: -12, type: 'improvement', platform: 'all', text: 'Easily select or deselect all filters in your calendar' },
      { id: -13, type: 'improvement', platform: 'all', text: 'Settings page UI refresh' },
    ],
  },
  {
    id: -3,
    version: '1.2.15',
    release_month: 1785542400, // 06 Aug 2026
    changelog_entry_items: [
      { id: -14, type: 'new_feature', platform: 'all', text: 'Home screen widget' },
      { id: -15, type: 'new_feature', platform: 'all', text: 'Doctor summary' },
    ],
  },
  {
    id: -4,
    version: '1.2.14',
    release_month: 1782864000, // 19 Jul 2026
    changelog_entry_items: [
      { id: -16, type: 'new_feature', platform: 'all', text: 'App tutorials to help you get started with Toastie' },
      { id: -17, type: 'improvement', platform: 'all', text: 'Minor improvements to the subscription screen' },
      { id: -18, type: 'bug_fix', platform: 'all', text: 'Fix bug on feedback page' },
      { id: -19, type: 'new_feature', platform: 'all', text: 'Added instructional dialog to enable notifications when creating a notification' },
      { id: -20, type: 'new_feature', platform: 'all', text: 'App shortcut to send feedback with us' },
    ],
  },
  {
    id: -5,
    version: '1.2.13',
    release_month: 1782864000, // 05 Jul 2026
    changelog_entry_items: [
      { id: -21, type: 'improvement', platform: 'all', text: 'Minor improvements to the onboarding experience' },
    ],
  },
  {
    id: -6,
    version: '1.2.12',
    release_month: 1782864000, // 01 Jul 2026
    changelog_entry_items: [
      { id: -22, type: 'new_feature', platform: 'all', text: 'Period prediction dates' },
      { id: -23, type: 'bug_fix', platform: 'all', text: 'De-duplicate edited notifications' },
      { id: -24, type: 'bug_fix', platform: 'all', text: 'Can log multiple symptoms and medications at once' },
    ],
  },
  {
    id: -7,
    version: '1.2.11',
    release_month: 1780272000, // 21 Jun 2026
    changelog_entry_items: [
      { id: -25, type: 'new_feature', platform: 'all', text: 'Insights month view' },
      { id: -26, type: 'new_feature', platform: 'all', text: 'Filter chips for calendar, timeline and year view' },
      { id: -27, type: 'new_feature', platform: 'all', text: 'Show different emotions for different moods selected' },
      { id: -28, type: 'new_feature', platform: 'all', text: 'Mood insights' },
      { id: -29, type: 'new_feature', platform: 'all', text: 'Social links on settings page' },
      { id: -30, type: 'new_feature', platform: 'all', text: 'Add time to stool and weight manual trackers' },
      { id: -31, type: 'new_feature', platform: 'all', text: 'Reset password' },
    ],
  },
  {
    id: -8,
    version: '1.2.10',
    release_month: 1780272000, // 02 Jun 2026
    changelog_entry_items: [
      { id: -32, type: 'new_feature', platform: 'all', text: 'New mood tracker!' },
    ],
  },
  {
    id: -9,
    version: '1.2.9',
    release_month: 1777593600, // 27 May 2026
    changelog_entry_items: [
      { id: -33, type: 'new_feature', platform: 'all', text: 'Health year view heatmap' },
      { id: -34, type: 'new_feature', platform: 'all', text: 'Export your toastie data' },
      { id: -35, type: 'new_feature', platform: 'all', text: 'Subscription code redemption' },
    ],
  },
  {
    id: -10,
    version: '1.2.8',
    release_month: 1775001600, // 30 Apr 2026
    changelog_entry_items: [
      { id: -36, type: 'new_feature', platform: 'all', text: 'Toastie pro' },
      { id: -37, type: 'new_feature', platform: 'all', text: 'Show thank you banner on feedback form submission' },
    ],
  },
  {
    id: -11,
    version: '1.2.7',
    release_month: 1775001600, // 24 Apr 2026
    changelog_entry_items: [
      { id: -38, type: 'improvement', platform: 'all', text: 'Replace meal type dropdowns with button options' },
      { id: -39, type: 'new_feature', platform: 'all', text: 'Add meal and symptom severity tags' },
      { id: -40, type: 'improvement', platform: 'all', text: 'Updated default images to meal cards' },
      { id: -41, type: 'improvement', platform: 'all', text: 'Calendar view is now accessible with larger text sizes' },
    ],
  },
  {
    id: -12,
    version: '1.2.6',
    release_month: 1772323200, // 11 Mar 2026
    changelog_entry_items: [
      { id: -42, type: 'bug_fix', platform: 'all', text: 'Fixed medication schedule deletion bug' },
      { id: -43, type: 'improvement', platform: 'all', text: 'Donation prices now shown in local currency' },
    ],
  },
  {
    id: -13,
    version: '1.2.5',
    release_month: 1772323200, // 10 Mar 2026
    changelog_entry_items: [
      { id: -44, type: 'bug_fix', platform: 'all', text: 'Fixed UI issue affecting calendar cards' },
      { id: -45, type: 'improvement', platform: 'all', text: 'Updated app typography' },
      { id: -46, type: 'improvement', platform: 'all', text: 'Redesigned home page' },
      { id: -47, type: 'improvement', platform: 'all', text: 'Period dates are now highlighted in the accent colour on the calendar' },
      { id: -48, type: 'improvement', platform: 'all', text: 'Insight cards can now be edited' },
    ],
  },
  {
    id: -14,
    version: '1.2.4',
    release_month: 1769904000, // 23 Feb 2026
    changelog_entry_items: [
      { id: -49, type: 'new_feature', platform: 'all', text: 'Added ability to edit or delete symptoms and medications from the search page' },
      { id: -50, type: 'improvement', platform: 'all', text: 'Brought back see summary for day feature' },
      { id: -51, type: 'improvement', platform: 'all', text: 'Refined calendar UI' },
      { id: -52, type: 'bug_fix', platform: 'all', text: 'Fixed onboarding entry point overflow issue' },
    ],
  },
  {
    id: -15,
    version: '1.2.3',
    release_month: 1769904000, // 12 Feb 2026
    changelog_entry_items: [
      { id: -53, type: 'bug_fix', platform: 'all', text: 'Fixed issues with notifications' },
      { id: -54, type: 'improvement', platform: 'all', text: 'All call-to-action buttons are now solid for better visibility' },
      { id: -55, type: 'new_feature', platform: 'all', text: 'Donation banner added to the Settings screen' },
      { id: -56, type: 'improvement', platform: 'all', text: 'Minor UI improvements' },
    ],
  },
  {
    id: -16,
    version: '1.2.2',
    release_month: 1767225600, // 20 Jan 2026
    changelog_entry_items: [
      { id: -57, type: 'improvement', platform: 'all', text: 'Revamped Settings page' },
      { id: -58, type: 'new_feature', platform: 'all', text: 'Added profile, share, and review options to the Settings page' },
      { id: -59, type: 'improvement', platform: 'all', text: 'Updated Donations page' },
    ],
  },
  {
    id: -17,
    version: '1.2.1',
    release_month: 1767225600, // 07 Jan 2026
    changelog_entry_items: [
      { id: -60, type: 'new_feature', platform: 'all', text: 'Enabled additional onboarding questions' },
      { id: -61, type: 'improvement', platform: 'all', text: 'Turned off automatic period logging while we fix an issue' },
      { id: -62, type: 'improvement', platform: 'all', text: 'Temporarily removed the calendar year view while we continue building and improving it' },
      { id: -63, type: 'improvement', platform: 'all', text: 'Removed the ‘Edit summary’ button from the home page (can access the details through Calendar / Timeline view)' },
    ],
  },
  {
    id: -18,
    version: '1.2.0',
    release_month: 1767225600, // 06 Jan 2026
    changelog_entry_items: [
      { id: -64, type: 'new_feature', platform: 'all', text: 'Personalised onboarding flow' },
      { id: -65, type: 'new_feature', platform: 'all', text: 'New Toastie logo' },
    ],
  },
  {
    id: -19,
    version: '1.1.9',
    release_month: 1764547200, // 19 Dec 2025
    changelog_entry_items: [
      { id: -66, type: 'new_feature', platform: 'all', text: 'Support and donate to Toastie!' },
    ],
  },
  {
    id: -20,
    version: '1.1.8',
    release_month: 1764547200, // 16 Dec 2025
    changelog_entry_items: [
      { id: -67, type: 'new_feature', platform: 'all', text: 'Manual tracker searches have new tap to edit cards' },
      { id: -68, type: 'improvement', platform: 'all', text: 'Change logic on the summary buttons to always open the tracker instead of the summary' },
      { id: -69, type: 'bug_fix', platform: 'all', text: 'Magic tracker fixes' },
    ],
  },
  {
    id: -21,
    version: '1.1.7',
    release_month: 1761955200, // 26 Nov 2025
    changelog_entry_items: [
      { id: -70, type: 'new_feature', platform: 'all', text: 'Tap on a card to edit' },
      { id: -71, type: 'new_feature', platform: 'all', text: 'Log multiple weight entries per day' },
      { id: -72, type: 'improvement', platform: 'all', text: 'Time editor using Cupertino style widgets' },
    ],
  },
  {
    id: -22,
    version: '1.1.6',
    release_month: 1759276800, // 02 Oct 2025
    changelog_entry_items: [
      { id: -73, type: 'new_feature', platform: 'all', text: 'Calendar view on period tracker' },
    ],
  },
  {
    id: -23,
    version: '1.1.5',
    release_month: 1756684800, // 28 Sep 2025
    changelog_entry_items: [
      { id: -74, type: 'new_feature', platform: 'all', text: 'Month view for calendar' },
      { id: -75, type: 'new_feature', platform: 'all', text: 'Customisable trackers on home and insights page' },
      { id: -76, type: 'bug_fix', platform: 'all', text: 'Period autologging fixed' },
      { id: -77, type: 'new_feature', platform: 'all', text: 'Add dose and dosage to new medications' },
      { id: -78, type: 'new_feature', platform: 'all', text: 'Logged lab reports show on home page' },
      { id: -79, type: 'new_feature', platform: 'all', text: 'Feedback form' },
    ],
  },
];
